import {SET_SNACKBAR} from "./actionTypes";

export function setSnackbar( snackbarOpen, snackbarType = "success", snackbarMessage = "") {
    return {
        type: SET_SNACKBAR,
        snackbarOpen,
        snackbarType,
        snackbarMessage
    }
}